import { Link } from 'react-router';
import { useProjects } from '../api/queries';
import { useTranslate } from '../i18n/useTranslate';
import { ErrorView } from '../ui/ErrorView';

/** Dikey dilimin ilk adımı: omurganın (auth + tenant + tipler) çalıştığını gösterir. */
export function ProjectListPage() {
  const t = useTranslate();
  const projects = useProjects();

  if (projects.isPending) return <p>{t('projects.loading')}</p>;
  if (projects.isError) return <ErrorView error={projects.error} onRetry={() => void projects.refetch()} />;

  return (
    <section>
      <h1>{t('projects.title')}</h1>

      {projects.data.length === 0 ? (
        <p>{t('projects.empty')}</p>
      ) : (
        <ul className="list">
          {projects.data.map((project) => (
            <li key={project.id}>
              <Link to={`/projects/${project.id}`}>{project.name}</Link>
              <span className="badge">{project.type}</span>
              <span className="badge">{project.status}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
